import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject
} from "@angular/core";
import Uppy, { UppyFile } from "@uppy/core";
import Dashboard from "@uppy/dashboard";
// @ts-ignore
import localeEn from "@uppy/locales/lib/en_US";
// @ts-ignore
import localeIt from "@uppy/locales/lib/it_IT";
import { TranslocoService } from "@jsverse/transloco";

@Directive({
  selector: "[uppy]",
  standalone: false
})
export class UppyDirective implements OnInit, OnDestroy {
  @Input()
  maxNumberOfFiles: number | undefined = undefined;

  @Input()
  allowedFileTypes: string[] | undefined = undefined;

  @Input()
  initialFiles: File[] | undefined;

  @Output()
  fileAdded: EventEmitter<UppyFile> = new EventEmitter();

  @Output()
  fileRemoved: EventEmitter<UppyFile> = new EventEmitter();

  private readonly translocoService = inject(TranslocoService);

  private uppy: Uppy | undefined;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    const currentLocale = this.translocoService.getActiveLang();

    this.elementRef.nativeElement.addEventListener(
      "click",
      this.stopClickListener.bind(this)
    );

    this.uppy = new Uppy({
      locale: currentLocale.startsWith("it") ? localeIt : localeEn,
      restrictions: {
        allowedFileTypes: this.allowedFileTypes,
        maxNumberOfFiles: this.maxNumberOfFiles || null
      }
    })
      .use(Dashboard, {
        hideCancelButton: true,
        hideUploadButton: true,
        fileManagerSelectionType: "files",
        inline: true,
        width: "100%",
        height: 308,
        target: this.elementRef.nativeElement,
        singleFileFullScreen: true
      })
      .on("file-added", (file: UppyFile) => {
        this.fileAdded.emit(file);
      })
      .on("file-removed", (file: UppyFile) => {
        this.fileRemoved.emit(file);
      });

    if (this.initialFiles?.length > 0) {
      this.initialFiles.forEach((file: File) => {
        this.uppy.addFile({
          name: file.name,
          type: file.type,
          data: file,
          source: "Local",
          isRemote: false
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener(
      "click",
      this.stopClickListener
    );
  }

  private stopClickListener(event: Event): void {
    event.stopImmediatePropagation();
  }
}
